import { FilterDropdown } from '@ui';
import { CASE_TYPE_FILTERS, caseTypeFilterItems } from '@/constants/filters';

type CaseTypeFilterDropdownProps = {
  opoRequest?: boolean;
  isReallocation?: boolean;
  onFiltersChange: (nextOpoRequest: boolean, nextIsReallocation: boolean) => void;
  size?: 'sm' | 'md';
  showResetButton?: boolean;
};

export const CaseTypeFilterDropdown = ({
  opoRequest,
  isReallocation,
  onFiltersChange,
  size = 'md',
  showResetButton,
}: CaseTypeFilterDropdownProps) => {
  const getSelectedKeys = () => {
    const selectedKeys = [];
    if (opoRequest) selectedKeys.push(CASE_TYPE_FILTERS.opoRequest);
    if (isReallocation) selectedKeys.push(CASE_TYPE_FILTERS.isReallocatedFromSource);
    return selectedKeys;
  };

  const onChange = (values: string[]) => {
    const nextOpoRequest = values.includes(CASE_TYPE_FILTERS.opoRequest);
    const nextIsReallocation = values.includes(CASE_TYPE_FILTERS.isReallocatedFromSource);
    onFiltersChange(nextOpoRequest, nextIsReallocation);
  };

  return (
    <FilterDropdown
      title="Case Type"
      items={caseTypeFilterItems}
      selectedKeys={getSelectedKeys()}
      mode="multiple"
      size={size}
      onSelectedKeysChange={onChange}
      showResetButton={showResetButton}
    />
  );
};
